import { SurveyQuestionTypeEnum } from '@elearning-platform/api-types/enums';
import { SurveyAnswerInterface, SurveyQuestionInterface } from '@elearning-platform/api-types/interfaces';

export const findAnswerId: (question: SurveyQuestionInterface, formValue: string | boolean) => number | undefined
= (question: SurveyQuestionInterface, formValue: string | boolean): number | undefined => {
  if (question.type === SurveyQuestionTypeEnum.SingleChoice) {
    return question.answers.find((answer: SurveyAnswerInterface): boolean => answer.answer === (formValue ? 'Tak' : 'Nie'))?.id;
  }

  return question.answers.find((answer: SurveyAnswerInterface): boolean => answer.editable)?.id;
};
